(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifWidgetText', swifWidgetText)
    .directive('swifWidgetColor', swifWidgetColor)
    .directive('swifWidgetEmail', swifWidgetEmail)
    .directive('swifWidgetTime', swifWidgetTime)
    .directive('swifWidgetCurrency', swifWidgetCurrency)
    .directive('swifWidgetPassword', swifWidgetPassword)
    .directive('swifWidgetPasswordChecker', swifWidgetPasswordChecker)
    .directive('swifWidgetNumber', swifWidgetNumber)
    .directive('swifWidgetDate', swifWidgetDate)
    .directive('swifWidgetDatetime', swifWidgetDatetime)
    .directive('swifWidgetDayLimit', swifWidgetDayLimit)
    .directive('swifWidgetDuration', swifWidgetDuration)
    .directive('swifWidgetSelectOne', swifWidgetSelectOne)
    .directive('swifWidgetSwitch', swifWidgetSwitch)
    .directive('swifWidgetRevertedSwitch', swifWidgetRevertedSwitch)
    .directive('swifWidgetTel', swifWidgetTel)
    .directive('swifWidgetSelectMultiple', swifWidgetSelectMultiple)
    .directive('swifWidgetSelectContainsMultiple', swifWidgetSelectContainsMultiple)
    .directive('swifWidgetRecurrence', swifWidgetRecurrence)
    .directive('swifWidgetBarcodeScanner', swifWidgetBarcodeScanner)
    .directive('swifWidgetFile', swifWidgetFile)
    .directive('swifWidgetTextarea', swifWidgetTextarea)
    .directive('swifWidgetSms', swifWidgetSms)
    .directive('swifWidgetSelectMultipleFreeChar', swifWidgetSelectMultipleFreeChar)
    .directive('swifWidgetMoveEquipment', swifWidgetMoveEquipment);

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetDayLimit
    * @module swif.ui
    * @restrict E
    * @description
    * Compare two fields and test whether the first one is lower than the second one.
    * Invalid the form if it's the case.
    * As the fields can be empty, we use 'text' fields cause Openerp don't handle Null values for 'number' type
    * @usage
    * <swif-widget-day-limit must-be-higher={{my_model}}></swif-widget-day-limit>
    * mustBeHigher: model name that you want to be higher
    **/

    function swifWidgetDayLimit(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.borderColor = '@?';
        d.templateUrl = 'partials/ui/widgetDayLimit.html';
        d.link = function(scope, element, attrs, ctrl) {

            var validate = function(viewValue) {
                var comparisonModel = attrs.mustBeHigher;
                var modelName = attrs.ngModel;

                if(scope.form[modelName]) {
                    if(!viewValue || !comparisonModel){
                        // Always validate if there is nothing to compare
                        scope.form[modelName].$setValidity('lowerThan', true);
                    } else {
                        // Valid if the model is lower than the compared model
                        scope.form[modelName].$setValidity('lowerThan', parseInt(viewValue, 10) < parseInt(comparisonModel, 10) );
                    }
                }
            };

            scope.$watch('proxy', function (newV) {
                validate(newV);
            });

            attrs.$observe('mustBeHigher', function(comparisonModel) {
                validate(ctrl.$viewValue);
            });

            swifFormUtility.falseProxyLink(scope, element, attrs, ctrl);
        };
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetText
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-text></swif-widget-text>
    **/
    function swifWidgetText(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.ngMaxlength = '@?';
        d.scope.ngMinlength = '@?';
        d.templateUrl = 'partials/ui/widgetText.html';
        d.link = swifFormUtility.falseProxyLink;
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetColor
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-color></swifW-wdget-color>
    **/
    function swifWidgetColor(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.templateUrl = 'partials/ui/widgetColor.html';
        d.link = swifFormUtility.falseProxyLink;
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetEmail
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-Email></swifW-wdget-email>
    **/
    function swifWidgetEmail(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.templateUrl = 'partials/ui/widgetEmail.html';
        d.link = function (scope, element, attr, ngModel) {
            scope.$watch('proxy', function (newV) {
                if (newV) {
                    var lower = angular.lowercase(newV);
                    if (lower !== newV) {
                        scope.proxy = lower;
                    }
                }
            });
            swifFormUtility.falseProxyLink(scope, element, attr, ngModel);
        };
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetTime
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-Time></swif-widget-time>
    **/
    function swifWidgetTime(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.templateUrl = 'partials/ui/widgetTime.html';
        d.link = function (scope, element, attr, ngModel) {
            swifFormUtility.watchNgRequired(scope, element);
            swifFormUtility.copyAttributesToInput(scope, element, attr);
            scope.form = scope.$parent.form;
            swifFormUtility.addOpenBoolean(scope, element);
            swifFormUtility.addTimeSupport(scope, element, attr, ngModel);
        };
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetCurrency
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-currency></swif-widget-currency>
    **/
    function swifWidgetCurrency(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.templateUrl = 'partials/ui/widgetCurrency.html';
        d.link = swifFormUtility.falseProxyLink;
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetPassword
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-password></swif-widget-password>
    **/
    function swifWidgetPassword(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.minlength = '=?';
        d.templateUrl = 'partials/ui/widgetPassword.html';
        d.link = swifFormUtility.passwordLink;
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetPasswordChecker
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-password></swif-widget-password>
    **/
    function swifWidgetPasswordChecker(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.minlength = '=?';
        d.templateUrl = 'partials/ui/widgetPasswordChecker.html';
        d.link = swifFormUtility.passwordLink;
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetNumber
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-number></swif-widget-number>
    **/
    function swifWidgetNumber(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.ngMin = '@?';
        d.templateUrl = 'partials/ui/widgetNumber.html';
        d.link = swifFormUtility.falseProxyLink;
        return d;
    }


    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetDate
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-date></swif-widget-date>
    **/
    function swifWidgetDate(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.minDate = '=?';
        d.scope.maxDate = '=?';
        d.scope.displaySpecialDay = '=?';
        d.scope.noTodayButton = '=?';
        d.scope.noCalandarButton = '=?';
        d.scope.noMargin = '=?';
        d.templateUrl = 'partials/ui/widgetDate.html';
        d.link = function (scope, element, attr, ngModel) {
            swifFormUtility.copyAttributesToInput(scope, element, attr);
            swifFormUtility.watchNgRequired(scope, element);
            //swifFormUtility.wrapNgModelWithProxy(scope, ngModel);
            swifFormUtility.addOpenBoolean(scope, element);
            scope.form = scope.$parent.form;
            swifFormUtility.addDateSupport(scope, element, attr, ngModel);
            swifFormUtility.addMinDateSupport(scope, element, attr, ngModel);
            swifFormUtility.addMaxDateSupport(scope, element, attr, ngModel);
        };
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetDatetime
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-datetime></swifWidget-datetime>
    **/
    function swifWidgetDatetime(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        swifFormUtility.datetimeDirective(d);
        d.scope.nowButton = '=?';
        d.templateUrl = 'partials/ui/widgetDatetime.html';
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetDuration
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-duration></swifWidget-duration>
    **/
    function swifWidgetDuration(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.templateUrl = 'partials/ui/widgetDuration.html';
        d.link = function (scope, element, attr, ngModel) {
            swifFormUtility.copyAttributesToInput(scope, element, attr);
            swifFormUtility.watchNgRequired(scope, element);
            scope.form = scope.$parent.form;
            scope.logKeyPressed = function($event) {
                console.log($event.keycode);
            };
            ngModel.$render = function () {
                var vv = ngModel.$viewValue;

                if (vv !== undefined) {
                    var mo = moment.duration({hours: vv});
                    scope.proxyH = Math.trunc(mo.asHours());
                    // Get minutes AND seconds from a duration to have all minutes left
                    scope.proxyM = Math.round(mo.minutes() + (mo.seconds()/60))
                } else {
                    delete scope.proxyH;
                    delete scope.proxyM;
                }
            };
            var updateModel = function (h, m) {
                var d;
                if (typeof h === 'number' && typeof m === 'number') {
                    d = moment.duration({
                        hours: h,
                        minutes: m
                    });
                    ngModel.$setViewValue(d.asHours());
                } else {
                    if (typeof scope.proxyM === 'number') {
                        scope.proxyH = 0; // update will be recall by watchers
                    } else if (typeof scope.proxyH === 'number') {
                        scope.proxyM = 0; // update will be recall by watchers
                    } else {
                        //make model empty
                        ngModel.$setViewValue(false);
                    }
                }
            };
            scope.$watch('proxyH', function (newV) {
                updateModel(newV, scope.proxyM);
            });
            scope.$watch('proxyM', function (newV) {
                updateModel(scope.proxyH, newV);
            });
        };
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetSelectOne
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-select-one></swif-widget-select-one>
    *
    * To allow the barcode search, add these two attributes :
    * barcode-mode="true"
    * limit-results="5" // The amount of limited results to show
    *                      A "load more" button will appear
    **/
    function swifWidgetSelectOne(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.choices = '=?';
        d.scope.filter = '=?';
        d.scope.type = '@?';
        d.scope.allowClear = '=?';
        // d.scope.ngModel = '=';
        // d.scope.selectionCallback = '&?';
        d.scope.formatName = '&?';
        d.scope.swifChange = '&?';
        d.scope.forceInit = '=?';
        d.scope.fullWidthView = '=?';
        d.scope.defaultSelected = '=?';
        d.scope.barcodeMode = '@?';
        d.scope.limitResults = '@?';
        // delete d.require;
        d.templateUrl = 'partials/ui/widgetSelectOne.html';
        d.link = function (scope, element, attr, ngModel) {
            ngModel.$viewChangeListeners.push(function () {
                if (scope.swifChange) {
                    scope.swifChange({$value: scope.proxy.selected});
                }
            });

            swifFormUtility.watchNgRequired(scope, element);
            scope.proxy = {selected: {}};
            scope.proxy.value = false;
            scope.proxy.widgetWidth = scope.fullWidthView ? "col-sm-5" : "";
            ngModel.$render = function () {
                scope.proxy.value = ngModel.$viewValue;
            };
            scope.proxyChange = function ($value) {
                scope.proxy.selected = $value;
                ngModel.$setViewValue(scope.proxy.value);
            };
            scope.proxyFormatName = function (val){
                if(scope.formatName !== undefined){
                    return scope.formatName({$value: val});
                }else{
                    return false;
                }
            };
        };
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetSelectMultiple
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-select-multiple></swif-widget-select-multiple>
    *
    * on-select="myFunctionFromController(item)" (optional) Catch the 'on-select' function from 'ui-select' and pass 'item' to this attribut.
    * You can pass your function from your controller to this attribut: Your controller function will be triggered when a tag will be selected from 'ui-select'.
    * validation-type-choices="mobile" (optional) Disable the item from the choices list according to the item member passed to this attribut
    **/
    function swifWidgetSelectMultiple(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.choices = '=?';
        d.scope.filter = '=?';
        d.scope.type = '@?';
        d.scope.validationTypeChoices = '@?';
        d.scope.allowClear = '=?';
        d.scope.formatName = '&?';
        d.scope.ngModel = '=';
        d.scope.limit = '=?';
        d.scope.onSelect = '&?';
        delete d.require;
        d.templateUrl = 'partials/ui/widgetSelectMultiple.html';
        d.link = function (scope, element) {
            swifFormUtility.watchNgRequired(scope, element);

            // Optional attribut
            if(scope.onSelect) {
                scope.updateOnSelect = function(item) {
                    scope.onSelect({item: item})
                };
            }

            scope.proxyFormatName = function (val){
                if(scope.formatName !== undefined){
                    return scope.formatName({$value: val});
                }else{
                    return false;
                }
            };
        };
        return d;
    }

    /**
     * @ngdoc directive
     * @name swif.ui:swifWidgetSelectMultiple
     * @module swif.ui
     * @restrict E
     * @description
     * @usage
     * <swif-widget-select-multiple></swif-widget-select-multiple>
     **/
    function swifWidgetSelectContainsMultiple(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.choices = '=?';
        d.scope.filter = '=?';
        d.scope.allowClear = '=?';
        d.scope.ngModel = '=';
        delete d.require;
        d.templateUrl = 'partials/ui/widgetSelectContainsMultiple.html';
        d.link = function (scope, element) {
            swifFormUtility.watchNgRequired(scope, element);
        };
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetSelectMultipleFreeChar
    * @module swif.ui
    * @restrict E
    * @description A multi select to add tags 'on the fly' without a prefilled dropdown
    * @usage
    * <swif-input-select-multiple-free-char ng-model="my_model" validation-type="directive_config_type"></swif-input-select-multiple-free-char>
    *
    * validation-type (optional) Disallow to add a tag according to the type passed to
    **/
    function swifWidgetSelectMultipleFreeChar(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.ngModel = '=';
        d.scope.validationType = '@?';
        d.templateUrl = 'partials/ui/widgetSelectMultipleFreeChar.html';
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetSwitch
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-switch></swif-widget-switch>
    **/
    function swifWidgetSwitch(swifFormUtility) {
        'ngInject';
        var d = swifFormUtility.checkboxDirective(d);
        d.templateUrl = 'partials/ui/widgetSwitch.html';
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetRevertedSwitch
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-reverted-switch></swif-widget-reverted-switch>
    **/
    function swifWidgetRevertedSwitch(swifFormUtility) {
        'ngInject';
        var d = swifFormUtility.revertedCheckboxDirective(d);
        d.templateUrl = 'partials/ui/widgetRevertedSwitch.html';
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetTel
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-tel></swif-widget-tel>
    **/
    function swifWidgetTel(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.templateUrl = 'partials/ui/widgetTel.html';
        d.link = swifFormUtility.telProxyLink;
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetTextarea
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-textarea></swif-widget-textarea>
    **/
    function swifWidgetTextarea(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.templateUrl = 'partials/ui/widgetTextarea.html';
        d.link = swifFormUtility.falseProxyLink;
        return d;
    }


    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetSms
    * @module swif.ui
    * @restrict E
    * @description Dynamically counts the total number of chars, SMS, chars left and detects encoding as the user types in the textarea.
    * It also display the unicode chars.
    * The number of chars that could be used per SMS depends on encoding. See https://en.wikipedia.org/wiki/SMS#Message_size
    *
    * @usage
    * <swif-widget-sms ng-model="my_model" show-count="true"></swif-widget-sms>
    *
    * `show-count` (optional) Set to true, it will show the html tag containing the number of chars and SMS
    **/
    function swifWidgetSms(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.templateUrl = 'partials/ui/widgetSms.html';
        d.scope.showCount = '=?';
        d.link = function (scope, element, attr, ngModel) {

            var config = {
                latin: 'latin',
                latin_EX: 'latin',
                unicode: 'unicode',
                gsm7bitChars: "@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\\\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà",
                gsm7bitExChars: "\\^{}\\\\\\[~\\]|€\\r\\n",
                messageLength: {
                    latin: 160,
                    latin_EX: 160,
                    unicode: 70
                },
                multiMessageLength: {
                    latin: 153,
                    latin_EX: 153,
                    unicode: 67
                },
                defaultValues: {
                    encoding: 'latin',
                    length: 0,
                    per_message: 160,
                    remaining: 160,
                    messages: 1
                }
            };

            var gsm7bitRegExp = RegExp("^[" + config.gsm7bitChars + "]*$");
            var gsm7bitExRegExp = RegExp("^[" + config.gsm7bitChars + config.gsm7bitExChars + "]*$");
            var gsm7bitExOnlyRegExp = RegExp("^[\\" + config.gsm7bitExChars + "]*$");

            // Counts the chars and the number of SMS depending on current encoding
            // Returns these values as an object
            var count = function(text) {
                var encoding, length, messages, per_message, remaining, unicodeChars;
                encoding = detectEncoding(text);
                length = text.length;
                if (encoding === config.latin_EX) {
                    length += countGsm7bitEx(text);
                } else if (encoding === config.unicode) {
                    unicodeChars = getUnicodeChars(text);
                }
                per_message = config.messageLength[encoding];
                if (length > per_message) {
                    per_message = config.multiMessageLength[encoding];
                }
                messages = Math.ceil(length / per_message);
                remaining = (per_message * messages) - length;
                if(remaining == 0 && messages == 0){
                    remaining = per_message;
                }
                return {
                    encoding: encoding,
                    length: length,
                    per_message: per_message,
                    remaining: remaining,
                    messages: messages,
                    unicodeChars: unicodeChars
                };
            };

            var detectEncoding = function(text) {
                switch (false) {
                    case text.match(gsm7bitRegExp) == null:
                        return config.latin;
                    case text.match(gsm7bitExRegExp) == null:
                        return config.latin_EX;
                    default:
                        return config.unicode;
                }
            };

            var getUnicodeChars = function(text) {
                let unicodeChars = text.match(RegExp("[^" + config.gsm7bitChars + config.gsm7bitExChars + "]", "g")).map(char => char === '\t' ? '→' : char);
                return unicodeChars ? unicodeChars.join(' ') : '';
            };

            // Some chars in 'Latin' mode counts as double chars
            // Calculate the total length according to these special characters
            var countGsm7bitEx = function(text) {
                var char2, chars;
                chars = (function() {
                    var _i, _len, _results;
                    _results = [];
                    for (_i = 0, _len = text.length; _i < _len; _i++) {
                        char2 = text[_i];
                        if (char2.match(gsm7bitExOnlyRegExp) != null) {
                            _results.push(char2);
                        }
                    }
                    return _results;
                }).call(this);
                return chars.length;
            };

            scope.$watch('proxy', function (newV) {
                if(newV) {
                    scope.sms = count(newV);
                } else {
                    scope.sms = config.defaultValues;
                }
                scope.$parent.encoding = scope.sms.encoding;
            });
            swifFormUtility.falseProxyLink(scope, element, attr, ngModel);
        };
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetRecurrence
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-recurrence></swif-widget-recurrence>
    **/
    function swifWidgetRecurrence(swifRecurrenceService) {
        'ngInject';
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                ngModel: '=' // BAD !! But necessary,
            },
            link: function (scope, element, attrs, ngModel) {
                var _getWeekday = function (date) {
                    var ret = '';
                    switch(date.weekday()) {
                        case 0:
                            ret = 'monday';
                            break;
                        case 1:
                            ret = 'tuesday';
                            break;
                        case 2:
                            ret = 'wednesday';
                            break;
                        case 3:
                            ret = 'thursday';
                            break;
                        case 4:
                            ret = 'friday';
                            break;
                        case 5:
                            ret = 'saturday';
                            break;
                        case 6:
                            ret = 'sunday';
                            break;
                    }
                    return ret;
                };

                var _getStrWeekdayPos = function (position) {
                    var ret = '';
                    switch(position) {
                        case 1:
                            ret = 'first';
                            break;
                        case 2:
                            ret = 'second';
                            break;
                        case 3:
                            ret = 'third';
                            break;
                        case 4:
                            ret = 'fourth';
                            break;
                        default:
                            ret = 'last';
                    }
                    return ret;
                };

                var defaultProxyValues = function (recurrence) {
                    if (recurrence.id){
                        return recurrence;
                    }else{
                        var now = recurrence.date_start ? moment(recurrence.date_start): moment();
                        var currentWeekday = _getWeekday(now);
                        var firstMonthday = moment().date(1);
                        // firstWeekdayPos refers to the day of month of the first occurence of "current-weekday"
                        var firstWeekdayPos = now.weekday() - firstMonthday.weekday();
                        // case when the current weekday is "lower" than the first weekday of the month
                        if(firstWeekdayPos < 0) {
                            firstWeekdayPos+= 7;
                        }
                        // weekdayPosition = nb of weeks from the first occurrence + 1
                        var weekdayPosition = 1 + parseInt((now.date() - firstWeekdayPos) / 7);
                        var ret = {
                            recur_type: 'daily',
                            recur_week_monday: false,
                            recur_week_tuesday: false,
                            recur_week_wednesday: false,
                            recur_week_thursday: false,
                            recur_week_friday: false,
                            recur_week_saturday: false,
                            recur_week_sunday: false,
                            recur_periodicity: 1,
                            recur_month_type: 'monthday',
                            recur_month_absolute: now.date(),
                            recur_month_relative_weight: _getStrWeekdayPos(weekdayPosition),
                            recur_month_relative_day: currentWeekday,
                            recur_length_type: 'count',
                            recur_occurrence_nb: 1,
                            date_start: now.format('YYYY-MM-DD HH:mm:00'),
                            date_end: now.format('YYYY-MM-DD')
                        };
                        ret['recur_week_' + currentWeekday] = true;
                        return ret;
                    }
                };

                var mergeDefaultValues = function (model, defaultValues) {
                    var tmpDefault = angular.copy(defaultValues);
                    var onlyIfEmpty = ['recur_type', 'recur_length_type', 'recur_occurrence_nb', 'date_start', 'date_end', 'recur_periodicity', 'recur_month_type'];
                    _.forEach(onlyIfEmpty, function (item) {
                        if (model[item]) {
                            delete tmpDefault[item];
                        }
                    });
                    _.merge(model, tmpDefault);
                };

                scope.form = scope.$parent.form;
                scope.defaultValues = {};
                ngModel.$render = function () {
                    if (!scope.proxy) {
                        scope.proxy = ngModel.$viewValue;
                    }
                    if (ngModel.$viewValue) {
                        // assign proxy and try to keep the initial object reference
                        scope.proxy = ngModel.$viewValue;
                        // apply default values to the proxy
                        scope.defaultValues = defaultProxyValues(ngModel.$viewValue);
                        mergeDefaultValues(scope.proxy, scope.defaultValues);
                        // finally, sync viewValue with current proxy value
                        ngModel.$setViewValue(scope.proxy);
                    }
                };

                // add a few fields of ngModel to be watched deeper than $render() does
                scope.$watch('ngModel.date_start', function (newV, oldV) {
                    if(newV !== oldV) {
                        // re-call the $render() method (same behavior)
                        scope.defaultValues = defaultProxyValues(ngModel.$viewValue);
                        // @TODO: we should propose the user to apply the new default values;
                        // instead of automatically overriding the object
                        mergeDefaultValues(scope.proxy, scope.defaultValues);
                   }
                });

                scope.$watch('proxy.recur_occurrence_nb', function (newV, oldV) {
                    if(!angular.equals(newV, oldV)) {
                        scope.proxy.recur_length_type = 'count';
                    }
                });

                scope.$watch('proxy.date_end', function (newV, oldV) {
                    if(!angular.equals(newV, oldV)) {
                        if (newV){
                            scope.proxy.recur_length_type = 'until';
                        }
                    }
                });

                scope.$watch('proxy', function (newV, oldV) {
                    if(!angular.equals(newV, oldV)) {
                        ngModel.$setViewValue(newV);
                    }
                }, true);

                scope.getDates = swifRecurrenceService.getDates;
            },
            templateUrl: 'partials/ui/widgetRecurrence.html'
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetBarcodeScanner
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-barcode-scanner></swif-widget-barcode-scanner>
    **/
    function swifWidgetBarcodeScanner($timeout) {
        'ngInject';
        return {
            restrict: 'E',
            // require: 'ngModel',
            scope: {
                callback: "=?"
            },
            link: function (scope, element, attrs, ngModel) {
                // for barcode scanner mode, we use an input as exclusive focus
                // to handle all strings sent to the modal,
                // really, really, really nasty, but works for now...
                // FIREFOX need to wait a bit before focus.

                /* method used internally to know if the input has or hasn't the focus
                 * as a string is displayed when input lost focus,
                 * and as we can click on the img to retrieve the focus,
                 * there is some millisconds where the string appears between 2 focusses
                 * if we repeatedly click on the img.
                 * That's why i put a timeout to trick this
                 */
                scope.setFocus = function (value) {
                    scope._focus = value;
                    if (value) {
                        scope._lostFocus = false;
                    } else {
                        $timeout(function () {
                            scope._lostFocus = !scope._focus;
                        }, 150);
                    }

                };
                scope.debug = '';
                $timeout(function() {
                    element.find('input').focus();
                }, 500);

                /* ngModel.$render = function () {
                    scope.proxy = ngModel.$viewValue;
                }; */
                scope.$watch('proxy', function (newV, oldV) {
                    if(newV !== oldV) {
                        if(newV) {
                            // ngModel.$setViewValue(newV);
                            var empty = true;

                            // Add leading EAN 13 '0' on 12 digits barcode
                            if (/^\d{12}$/.test(newV)) {
                                newV = '0' + newV;
                            }

                            if(scope.callback) {
                                empty = scope.callback(newV);
                                scope.proxy = '';
                            }
                            if (!empty) {
                                scope.debug += ' ' + newV;
                            }
                        }
                    }
                });
            },
            templateUrl: 'partials/ui/widget_barcode_scanner.html'
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetFile
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-file></swif-widget-file>
    **/
    function swifWidgetFile(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.accept = '@';
        d.scope.encode = '=?';
        d.templateUrl = 'partials/ui/widgetFile.html';
        d.link = function (scope, element, attr, ngModel) {
            if (scope.encode !== false) {  // if null or undefined
                scope.encode = true;
            }
            swifFormUtility.falseProxyLink(scope, element, attr, ngModel);
            if (!scope.accept) {
                scope.accept = 'image/*';
            }
            scope.filename = '';
            scope.sync = function (value, filename) {
                scope.proxy = value;
                scope.filename = filename;
            };
            scope.swifChangeContext = function () {
                return {filename: scope.filename};
            };

        };
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifWidgetMoveEquipment
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    * <swif-widget-move-equipment></swif-widget-move-equipment>
    **/
     function swifWidgetMoveEquipment(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.templateUrl = 'partials/ui/widgetMoveEquipment.html';
        d.link = function (scope, element, attr, ngModel) {
            scope.proxy = {selected: ""};
            ngModel.$render = function () {
                scope.proxy.selected = ngModel.$viewValue;
            }
            scope.proxyChange = function ($value) {
                scope.proxy.selected = $value;
                ngModel.$setViewValue(scope.proxy.selected);
            }
        };
        return d;
    }

})();
